import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pgfx-admin-token";
const EMAIL_KEY = "pgfx-admin-email";

export const getToken = () => {
    try { return window.localStorage.getItem(TOKEN_KEY); } catch (_e) { return null; }
};
export const getAdminEmail = () => {
    try { return window.localStorage.getItem(EMAIL_KEY); } catch (_e) { return null; }
};
export const setSession = (token, email) => {
    try {
        window.localStorage.setItem(TOKEN_KEY, token);
        if (email) window.localStorage.setItem(EMAIL_KEY, email);
    } catch (_e) { /* ignore */ }
};
export const clearSession = () => {
    try {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.removeItem(EMAIL_KEY);
    } catch (_e) { /* ignore */ }
};

export const adminClient = () => {
    const token = getToken();
    return axios.create({
        baseURL: API,
        timeout: 25000,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

export const login = async (email, password) => {
    const res = await axios.post(`${API}/admin/login`, { email, password }, { timeout: 20000 });
    const { access_token, email: e } = res.data;
    setSession(access_token, e);
    return res.data;
};

export const fetchMe = async () => {
    const res = await adminClient().get("/admin/me");
    return res.data;
};

export const fetchInquiries = async (params = {}) => {
    const res = await adminClient().get("/admin/inquiries", { params });
    return res.data;
};

export const fetchInquiryStats = async () => {
    const res = await adminClient().get("/admin/inquiries/stats");
    return res.data;
};

export const updateInquiryStatus = async (id, status, notes = null) => {
    const res = await adminClient().patch(`/admin/inquiries/${id}`, { status, ...(notes !== null ? { notes } : {}) });
    return res.data;
};

export const fetchProjects = async (params = {}) => {
    const res = await adminClient().get("/admin/projects", { params });
    return res.data;
};

export const createProject = async (payload) => {
    const res = await adminClient().post("/admin/projects", payload);
    return res.data;
};

export const updateProject = async (id, payload) => {
    const res = await adminClient().patch(`/admin/projects/${id}`, payload);
    return res.data;
};

export const deleteProject = async (id) => {
    const res = await adminClient().delete(`/admin/projects/${id}`);
    return res.data;
};

export const lookupDelivery = async (code) => {
    const res = await axios.post(`${API}/delivery/lookup`, { code: (code || "").trim().toUpperCase() }, { timeout: 15000 });
    return res.data;
};


// ---- Site Content CMS ----
export const fetchPublicSiteContent = async () => {
    const res = await axios.get(`${API}/site-content`, { timeout: 12000 });
    return res.data;
};

export const fetchAdminSiteContent = async () => {
    const res = await adminClient().get(`/admin/site-content`);
    return res.data;
};

export const saveAdminSiteContent = async (payload) => {
    const res = await adminClient().put(`/admin/site-content`, payload);
    return res.data;
};

export const resetAdminSiteContent = async () => {
    const res = await adminClient().post(`/admin/site-content/reset`);
    return res.data;
};

// ---- Catalog (Packages + Addons) ----
export const fetchAdminCatalog = async () => {
    const res = await adminClient().get(`/admin/catalog`);
    return res.data;
};
export const createPackage = async (payload) => (await adminClient().post(`/admin/packages`, payload)).data;
export const updatePackage = async (id, payload) => (await adminClient().put(`/admin/packages/${id}`, payload)).data;
export const deletePackage = async (id) => (await adminClient().delete(`/admin/packages/${id}`)).data;
export const reorderPackages = async (ids) => (await adminClient().post(`/admin/packages/reorder`, { ids })).data;
export const createAddon = async (payload) => (await adminClient().post(`/admin/addons`, payload)).data;
export const updateAddon = async (id, payload) => (await adminClient().put(`/admin/addons/${id}`, payload)).data;
export const deleteAddon = async (id) => (await adminClient().delete(`/admin/addons/${id}`)).data;
export const resetCatalog = async () => (await adminClient().post(`/admin/catalog/reset`)).data;

// ---- Portfolio CMS ----
export const fetchAdminPortfolio = async () => (await adminClient().get(`/admin/portfolio`)).data;
export const createBrandingItem = async (payload) => (await adminClient().post(`/admin/portfolio/branding`, payload)).data;
export const updateBrandingItem = async (id, payload) => (await adminClient().put(`/admin/portfolio/branding/${id}`, payload)).data;
export const deleteBrandingItem = async (id) => (await adminClient().delete(`/admin/portfolio/branding/${id}`)).data;
export const createVideoItem = async (payload) => (await adminClient().post(`/admin/portfolio/video`, payload)).data;
export const updateVideoItem = async (id, payload) => (await adminClient().put(`/admin/portfolio/video/${id}`, payload)).data;
export const deleteVideoItem = async (id) => (await adminClient().delete(`/admin/portfolio/video/${id}`)).data;
export const resetPortfolio = async () => (await adminClient().post(`/admin/portfolio/reset`)).data;
export const lookupBehance = async (url) => (await adminClient().post(`/admin/portfolio/lookup`, { url })).data;

// ---- Reviews CMS ----
export const fetchAdminReviews = async () => (await adminClient().get(`/admin/reviews`)).data;
export const createReview = async (payload) => (await adminClient().post(`/admin/reviews`, payload)).data;
export const updateReview = async (id, payload) => (await adminClient().put(`/admin/reviews/${id}`, payload)).data;
export const deleteReview = async (id) => (await adminClient().delete(`/admin/reviews/${id}`)).data;
export const reorderReviews = async (ids) => (await adminClient().post(`/admin/reviews/reorder`, { ids })).data;

// ---- Hero Rail CMS ----
export const fetchAdminHeroRail = async () => (await adminClient().get(`/admin/hero-rail`)).data;
export const createHeroRailItem = async (payload) => (await adminClient().post(`/admin/hero-rail`, payload)).data;
export const updateHeroRailItem = async (id, payload) => (await adminClient().put(`/admin/hero-rail/${id}`, payload)).data;
export const deleteHeroRailItem = async (id) => (await adminClient().delete(`/admin/hero-rail/${id}`)).data;
export const reorderHeroRail = async (ids) => (await adminClient().post(`/admin/hero-rail/reorder`, { ids })).data;

// ---- Coupons ----
export const fetchAdminCoupons = async () => (await adminClient().get(`/admin/coupons`)).data;
export const createCoupon = async (payload) => (await adminClient().post(`/admin/coupons`, payload)).data;
export const updateCoupon = async (id, payload) => (await adminClient().put(`/admin/coupons/${id}`, payload)).data;
export const deleteCoupon = async (id) => (await adminClient().delete(`/admin/coupons/${id}`)).data;
// Public — used by the inquiry Review step (no auth).
export const validateCoupon = async (code) => (await axios.post(`${API}/coupon/validate`, { code: (code || "").trim() }, { timeout: 15000 })).data;

